import {useContext} from "react";
import {useLocation} from "react-router-dom";
import {Helmet, HelmetProvider} from "react-helmet-async";
import {ReducerStateInterface} from "../../interfaces/core/ReducerStateInterface";
import {GlobalContext} from "../../GlobalReducer";

export default function MetaParams() {
    const [state] = useContext<[ReducerStateInterface, Function]>(GlobalContext);

    const location = useLocation()

    const getCanonical = () => {
        let canonical = 'https://b2b.pride.ru' + window.location.pathname;
        return canonical
    }

    return (<HelmetProvider>
        <Helmet>
            { /* Standard metadata tags */}
            {state.meta?.title && <title>{state.meta.title}</title>}
            {state.meta?.description && <meta name="description" content={state.meta.description}/>}
            {state.meta?.meta_tags && state.meta.meta_tags.map(tag => tag.name !== 'canonical' &&
                <meta name={tag.name} content={tag.value}/>
            )}
            <link rel="canonical" href={getCanonical()}/>

            <meta property="og:title" content={state.meta?.html_header || state.meta?.title}/>
            <meta property="og:type" content={'website'}/>
            <meta property="og:description" content={state.meta?.description}/>
            <meta property="og:url" content={"https://b2b.pride.ru" + location.pathname}/>
            <meta property="og:locale" content="ru_RU"/>
            <meta property="og:image" content={state.meta?.image || "https://b2b.pride.ru/public/new-design/main/top-logo.svg"}/>
            <meta property="og:site_name" content="Pride"/>

        </Helmet>
    </HelmetProvider>)

}